export const isCuitValid = (cuit: string): boolean => {
  if (cuit.length !== 11 || !/^\d+$/.test(cuit)) return false;

  const coeficientes = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  const digitos = cuit.split('').map(Number);
  const verificador = digitos.pop()!;

  const suma = digitos.reduce((acc, val, i) => acc + val * coeficientes[i], 0);
  const resto = suma % 11;
  const digitoCalculado = resto === 0 ? 0 : resto === 1 ? 9 : 11 - resto;

  return digitoCalculado === verificador;
};

export const handleCuitInput = (e: React.FormEvent<HTMLInputElement>) => {
  const target = e.target as HTMLInputElement;
  target.value = target.value.replace(/\D/g, '');
};
